module.exports = Object.freeze({
    NavigationTypes:{
        Music:'Music',
        Blockchain:'Blockchain'
    }
})